<iframe *ngIf="data?.doc" [src]="link" width="768" height="444"></iframe>

<div>
  <a [href]="link" target="_blank" class="download-pdf" data-qa-link="document">
    <svg-icon key="docs"></svg-icon>
    {{ 'kkm.action.sign.download' | translate }}
  </a>

  <div class="ui-kit-bottom-buttons-block">
    <button data-qa-button="go-back" class="back-button" (click)="back()" translate>
      group.back
    </button>
    <div>
      <button
        *ngIf="data"
        class="button_blue"
        data-qa-button="sign-document"
        [taxOpenCertificateModal]="{ data }"
        (signatureGenerated)="setSignature($event)"
        (click)="emitYandexGoal()"
        translate
      >
        sign.by.eds.button
      </button>
      <button
        data-qa-button="sign-by-sms"
        *ngIf="kkmForm?.fields?.singBySmsAllowed === 'true'"
        class="button_blue"
        (click)="signBySms()"
        translate
      >
        sign.by.sms.button
      </button>
    </div>
  </div>
</div>
